import React, { FC, useMemo } from 'react';
import { FinancialNotificationEventType } from 'api/settings-financials/types';
import { PageLoading } from 'components/atoms/loading';
import { MaskableContent } from 'components/atoms/maskable-content';
import { AccountFeature } from 'hooks/use-account-feature';
import { useFinancialNotificationsConfigQuery } from 'queries/financial-notifications';
// import { AccountCurrency } from './account-currency';
import { AlertInfo } from './alert-table';
import { FinancialAlertChannelsToggle } from './channels-toggle';
import { EnableAccounting } from './enable-accounting';
import { Section, Divider, InfoWrapper } from './styles';
import { useFeatureSettings } from './use-financials';

export const FinancialsPage: FC = () => {
  const { data, isLoading } = useFinancialNotificationsConfigQuery();

  const [featureEnabled, setFeatureEnabled] = useFeatureSettings(
    AccountFeature.Financials,
  );
  const budgetAlerts = useMemo(() => {
    const budgetConfig = (data ?? []).find(
      (config) =>
        config.eventType ===
        FinancialNotificationEventType.ProjectBudgetThresholdReached,
    );

    if (budgetConfig) {
      return {
        configId: budgetConfig?.accountNotificationConfigId,
        alerts:
          budgetConfig?.accountNotificationConfigurationMeta
            ?.projectThresholdNotificationConditions || [],
        channels: budgetConfig.channels,
        response: budgetConfig,
      };
    }

    return null;
  }, [data]);

  const projectHourAlerts = useMemo(() => {
    const projectHoursConfig = (data ?? []).find(
      (config) =>
        config.eventType ===
        FinancialNotificationEventType.ProjectHoursThresholdReached,
    );

    if (projectHoursConfig) {
      return {
        configId: projectHoursConfig?.accountNotificationConfigId,
        alerts:
          projectHoursConfig?.accountNotificationConfigurationMeta
            ?.projectThresholdNotificationConditions || [],
        channels: projectHoursConfig.channels,
        response: projectHoursConfig,
      };
    }

    return null;
  }, [data]);

  return (
    <>
      {/* <AccountCurrency />
      <Divider /> */}
      <InfoWrapper>
        <EnableAccounting
          enabled={featureEnabled}
          onStateChange={setFeatureEnabled}
        />
      </InfoWrapper>
      <Divider />
      <MaskableContent showMask={!featureEnabled}>
        <Section>
          {isLoading ? (
            <PageLoading />
          ) : (
            <>
              {budgetAlerts && projectHourAlerts ? (
                <InfoWrapper>
                  <FinancialAlertChannelsToggle
                    budgetConfig={budgetAlerts.response}
                    projectHours={projectHourAlerts.response}
                    projectBudgetConfigId={budgetAlerts.configId}
                    projectHoursConfigId={projectHourAlerts.configId}
                  />
                </InfoWrapper>
              ) : null}
              {budgetAlerts ? (
                <AlertInfo
                  type={
                    FinancialNotificationEventType.ProjectBudgetThresholdReached
                  }
                  alerts={budgetAlerts.alerts}
                  configId={budgetAlerts.configId}
                />
              ) : null}

              {projectHourAlerts ? (
                <AlertInfo
                  type={
                    FinancialNotificationEventType.ProjectHoursThresholdReached
                  }
                  alerts={projectHourAlerts.alerts}
                  configId={projectHourAlerts.configId}
                />
              ) : null}
            </>
          )}
        </Section>
      </MaskableContent>
    </>
  );
};
